import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { MethodReveal } from '../components/MethodReveal';
import { ProductDetails } from '../components/ProductDetails';
import { ValueAndAudience } from '../components/ValueAndAudience';
import { ROIAndTestimonials } from '../components/ROIAndTestimonials';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-cream-50 overflow-hidden" data-id="element-396">
      <HeroSection data-id="element-397" />
      <StorySection data-id="element-398" />
      <MethodReveal data-id="element-399" />
      <ProductDetails data-id="element-400" />
      <ValueAndAudience data-id="element-401" />
      <ROIAndTestimonials data-id="element-402" />
      <FAQSection data-id="element-403" />
      <PricingSection data-id="element-404" />
      <Footer data-id="element-405" />
    </main>;
}